module.exports = __webpack_public_path__ + "img/MixedCells_2.97a3073d.png";